<button id="loginButton" class="login-button align-self-center" (click)="openLoginModal($event)">
  <!--  TODO(Jovana): Research ngrx-translate so that no placeholder data is ever shown-->
  Login
  <!--  {{ 'HEADER.LOGIN' | translate }}-->
</button>
